var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCexcel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30032 15.8768C2.7736 15.4098 2.7736 14.6527 2.30032 14.1857C1.82704 13.7188 1.05971 13.7188 0.586435 14.1857C0.113159 14.6527 0.113159 15.4098 0.586435 15.8768C1.05971 16.3437 1.82704 16.3437 2.30032 15.8768Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44331 16.4536C0.647605 16.4536 0 15.8146 0 15.0295C0 14.2444 0.647605 13.6055 1.44331 13.6055C2.23902 13.6055 2.88663 14.2444 2.88663 15.0295C2.88663 15.8146 2.23902 16.4536 1.44331 16.4536ZM1.44331 14.0621C0.902517 14.0621 0.462829 14.4959 0.462829 15.0295C0.462829 15.5631 0.902517 15.9969 1.44331 15.9969C1.98411 15.9969 2.4238 15.5631 2.4238 15.0295C2.4238 14.4959 1.98411 14.0621 1.44331 14.0621Z",
    fill: "#206D15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3382 0.230469H4.44139C2.83181 0.230469 1.52734 1.51788 1.52734 3.10563V16.8987C1.52734 18.4868 2.83217 19.7738 4.44139 19.7738H12.8542C14.4638 19.7738 15.7682 18.4864 15.7682 16.8987V5.58806L10.3382 0.230469Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3382 0.230469H4.44139C2.83181 0.230469 1.52734 1.51788 1.52734 3.10563V16.8987C1.52734 18.4868 2.83217 19.7738 4.44139 19.7738H12.8542C14.4638 19.7738 15.7682 18.4864 15.7682 16.8987V5.58806L10.3382 0.230469Z",
    fill: "url(#paint0_linear_2830_42137)",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8542 20H4.44136C2.70681 20 1.2959 18.6079 1.2959 16.8965V3.10348C1.2959 1.39209 2.70681 0 4.44136 0H10.3382C10.3994 0 10.4585 0.0238865 10.5019 0.0667416L15.9316 5.42434C15.9751 5.46719 15.9993 5.52515 15.9993 5.58592V16.8969C15.9993 18.6083 14.5883 20.0004 12.8538 20.0004L12.8542 20ZM4.44136 0.456653C2.96208 0.456653 1.75873 1.64395 1.75873 3.10348V16.8965C1.75873 18.356 2.96208 19.5433 4.44136 19.5433H12.8542C14.3334 19.5433 15.5368 18.356 15.5368 16.8965V5.68041L10.2424 0.456653H4.44136Z",
    fill: "#206D15"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7686 5.81433C15.7686 5.81433 15.7683 5.81433 15.7679 5.81433H11.496C10.7298 5.81433 10.1064 5.19925 10.1064 4.44331V0.228405C10.1064 0.136021 10.1627 0.0527696 10.2492 0.0172912C10.3357 -0.017836 10.4351 0.00148394 10.5013 0.0668205L15.9206 5.41388C15.9691 5.45568 15.9997 5.51715 15.9997 5.58565C15.9997 5.71175 15.8961 5.81397 15.7683 5.81397L15.7686 5.81433ZM10.5693 0.779551V4.44331C10.5693 4.94739 10.9848 5.35767 11.496 5.35767H15.2093L10.5693 0.779551Z",
    fill: "#206D15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55437 8.13672C0.834497 8.13672 0.250977 8.71245 0.250977 9.42272V14.8081H0.27483C0.390893 14.2151 0.919231 13.7669 1.55437 13.7669H14.6802V8.13672H1.55437Z",
    fill: "#206D15"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85698 9V9.416H5.47183V10.4171H6.81126V10.824H5.47183V11.8297H6.88898V12.2457H5.00098V9H6.85698Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44019 12.2457L8.61733 10.9429L7.77619 12.2457H7.25962L8.35219 10.5817L7.30991 9H7.86305L8.63562 10.2206L9.41276 9H9.90648L8.90533 10.5771L9.98419 12.2457H9.44019Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.326 11.8206V12.2457H10.4563V9H10.9272V11.8206H12.326Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0.274799 15.0343H0.250946C0.123134 15.0343 0.0195312 14.932 0.0195312 14.8059V9.42058C0.0195312 8.58561 0.708078 7.90625 1.55434 7.90625H14.6802C14.808 7.90625 14.9116 8.00847 14.9116 8.13458V13.7648C14.9116 13.8909 14.808 13.9931 14.6802 13.9931H1.55434C1.04167 13.9931 0.599136 14.3531 0.501942 14.8491C0.480936 14.9566 0.385522 15.0343 0.274799 15.0343ZM1.55434 8.3629C0.963346 8.3629 0.48236 8.83747 0.48236 9.42058V13.9674C0.761482 13.6991 1.14207 13.5364 1.55434 13.5364H14.4488V8.3629H1.55434Z",
    fill: "#206D15"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2830_42137",
    x1: 5.18049,
    y1: 17.8116,
    x2: 2.59889,
    y2: 9.19966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F36C7"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCexcel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Cexcel.938b9ecd860ca6f6712c21fa4d68f645.svg";